module.exports = __webpack_public_path__ + "static/media/akacia-standart.c9a75bf2.jpg";